import React, { Component } from "react";
import { Modal, Form, FormInstance, Checkbox } from "antd";

interface FormProps {
    data: any,
    visible: boolean,
    onCreate: (values: any) => void,
    onCancel: () => void,
}

class DeleteAdmin extends Component<FormProps> {
    
    formRelf;
    constructor (props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    render () {

        const { visible, onCancel, onCreate, data } = this.props;
        const layout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 19 },
        };

        let roles = data.roles || '';
        let admin = roles.split(',').find((a) => a === '管理员');
        let staff = roles.split(',').find((a) => a === '店员');

        return (
            <Modal
                maskClosable={false}
                destroyOnClose={true}
                open={visible}
                title='删除权限'
                okText='确定'
                cancelText='取消'
                onCancel={onCancel}
                onOk={
                    () => {
                        this.formRelf.current!.validateFields().then(values => {
                            this.formRelf.current!.resetFields();
                            onCreate(values);
                        }).catch(info => {
                            console.log('Valide Failed:', info);
                        })
                    }
                }
            >
                <Form
                    {...layout}
                    ref={this.formRelf}
                    layout='horizontal'
                    name='form'
                    >
                    <Form.Item label="角色" name="role" rules={[{required: true, message: '请选择角色'}]} >
                        <Checkbox.Group>
                            <Checkbox value='admin' disabled={!admin}>管理员(可登录后台)</Checkbox>
                            <Checkbox value='staff' disabled={!staff}>店员(仅可使用设备检测)</Checkbox>
                        </Checkbox.Group>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default DeleteAdmin